/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FetchRetailRequestTypes } from '../actions/RetailActions';
import RequestStatus from '../constants/RequestStatus';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
export const isRetailSelector = ({
  retail
}) => retail;
const fetchRetailStatus = makeRequestStatusSelector(FetchRetailRequestTypes.REQUEST);
export const useTrackRetail = () => {
  const isRetail = useSelector(isRetailSelector);
  const hasRetailFetchSucceeded = useSelector(fetchRetailStatus) === RequestStatus.SUCCEEDED;
  useEffect(() => {
    if (hasRetailFetchSucceeded) getUsageTracker().setProperties({
      isRetail
    });
  }, [hasRetailFetchSucceeded]);
};